import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import Drawer from 'react-modern-drawer'; 
import Matching_Territory from "./Matching_Territory";
import Matching_Format from "./Matching_Format";
import Matching_Catalog from "./Matching_Catalog";
import Matching_Song from "./Matching_Song";

export default function MatchingForm(param: any) {

    console.log(param)
    let [showtab, setShowTab] = useState(1);
    let [postFactSalesCommitTrue, setPostFactSalesCommitTrue] = useState(false);
    let [postFactSalesCommitFalse, setPostFactSalesCommitFalse] = useState(false);
    const currentPage = (e: number) => { setShowTab(e); }
    const MatchingTerritoriesClose = () => { param.MatchingTerritoriesClose() }

    const Data: any = { pageSize: 10, pageNumber: 1, totalRows: 0 }

    return (
        <Drawer open={param.param} onClose={MatchingTerritoriesClose} direction='right' className='react-drawer allowHscroll allowvscroll' size={1200}>

            <div className="ws-10 box pull-right allowHscroll allowvscroll">
                <div className="box-content ">
                    <ul className="nav nav-tabs nav-justified">
                        <a id="1" className={showtab === 1 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(1)}>Matching Territories</a>
                        <a id="2" className={showtab === 2 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(2)}>Matching Formats/Source Codes</a>
                        <a id="3" className={showtab === 3 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(3)}>Matching Catalogs</a>
                        <a id="4" className={showtab === 4 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => currentPage(4)}>Matching Songs</a>
                    </ul>

                    {postFactSalesCommitTrue && <div className="alert alert-info">Operation successfully queued for processing</div>}
                    {postFactSalesCommitFalse && <div className="alert alert-info">Re-run this operation after a few mins as same operation already in progress</div>}

                    {showtab === 1 && <Matching_Territory />}

                    {showtab === 2 && <Matching_Format />}

                    {showtab === 3 && <Matching_Catalog />}

                    {showtab === 4 && <Matching_Song />}
                </div>

                <div className="box-footer">
                    <button className="btn icon-btn delete btn-sm " onClick={MatchingTerritoriesClose}><i className="icon-close"></i>Close</button>
                    <button className="btn icon-btn edit btn-sm hide " data-ng-click="updateSystem()"><i className="icon-save"></i> Update system</button>
                    <button className="btn icon-btn edit btn-sm hide" data-ng-click="postFactSalesRaw()" data-ng-show="tabs.active == 2 || tabs.active == 3"><i className="icon-tick"></i> Commit</button>
                </div>
            </div>

        </Drawer>
    )
}